// Session max HR (held 5 s, from the server's max_hr_bpm) + "update your profile?" prompt.
import { useState } from 'react';
import { toast } from 'sonner';
import { MAX_HR_RANGE } from '@/lib/hrZones';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const dismissKey = (id) => `maxhr_prompt_dismissed_${id}`;

export const SessionMaxHr = ({ workout, profileMaxHr, onProfileUpdated }) => {
  const id = workout.workout_id;
  const x = workout.max_hr_bpm;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(dismissKey(id)) === '1');
  const [saving, setSaving] = useState(false);
  const showPrompt = x && profileMaxHr && x > profileMaxHr && x >= MAX_HR_RANGE[0] && x <= MAX_HR_RANGE[1] && !dismissed;

  const dismiss = () => { localStorage.setItem(dismissKey(id), '1'); setDismissed(true); };
  const accept = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${API}/user/profile`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hr_max_setting_bpm: x }),
      });
      if (!res.ok) throw new Error((await res.json()).detail || 'Update failed');
      toast.success(`Max HR updated to ${x} bpm`);
      onProfileUpdated?.(x);
      dismiss();
    } catch (e) {
      toast.error(String(e.message || e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mb-3" data-testid={`session-max-hr-${id}`}>
      <div className="flex items-baseline gap-2">
        <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-400">Max HR</span>
        <span className="text-sm font-bold text-zinc-800" style={{ fontFamily: 'JetBrains Mono, monospace' }} data-testid={`session-max-hr-value-${id}`}>
          {x ? `${x} bpm` : '—'}
        </span>
        <span className="text-[10px] text-zinc-400">held 5 s</span>
      </div>
      {showPrompt && (
        <div className="mt-2 flex flex-wrap items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold text-red-700" data-testid={`max-hr-prompt-${id}`}>
          <span>New max HR {x} bpm — update your profile?</span>
          <span className="ml-auto flex gap-2">
            <button type="button" onClick={accept} disabled={saving} className="rounded-md bg-red-600 px-3 py-1 font-bold text-white transition-colors hover:bg-red-700 disabled:opacity-60" data-testid={`max-hr-prompt-yes-${id}`}>Yes</button>
            <button type="button" onClick={dismiss} className="rounded-md border border-red-300 px-3 py-1 font-bold transition-colors hover:bg-red-100" data-testid={`max-hr-prompt-no-${id}`}>No</button>
          </span>
        </div>
      )}
    </div>
  );
};
